export default "__VITE_ASSET__CQyfv_jw__"